import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import style from "./style"
// import CustomPagination from "../../../../components/CustomPagination"
import { Delete, Edit } from "@mui/icons-material"
import Modal from "../../../../components/Modal"
import color from "../../../../constants/color"

function ProjectPage({ handleProject, projectList, updateProject, clear, open, setOpen, handleDelete, loading }) {
  const [from, setFrom] = useState("");
  const [item, setItem] = useState("");
  const [project, setProject] = useState(item?.name || "");
  const [status, setStatus] = useState(item?.status || "");
  const [change, setChange] = useState(false);
  const [opens, setOpens] = useState(false);
  const [value, setValue] = useState();
  const [isChanged, setIsChanged] = useState(false);
  const role = localStorage.getItem("role");
  const isEmployeeRole = role === "Employee" || role === "employee";

  const deleteData = (item) => {
    setValue(item);
  }

  const handleDeleteItem = () => {
    handleDelete(value);
    setOpens(false);
  };

  useEffect(() => {
    setFrom("");
    setStatus("");
    setItem("");
    setProject("");
    setChange(false);
  }, [clear])

  useEffect(() => {
    if (from === "Edit" && item) {
      setProject(item.name || "");
      setStatus(item.status || "");
    }
  }, [from, item]);

  useEffect(() => {
    if (from === "Edit" && item) {
      const hasChanges =
        project.trim() !== "" &&
        status.trim() !== "" &&
        (project !== (item.name || "") || status !== (item.status || ""));

      setIsChanged(hasChanges);
    } else {
      // For create mode
      setIsChanged(project.trim() !== "");
    }
  }, [project, status, from, item]);
  
  const handleSubmit = () => {
    if (from === "Edit") {
      updateProject(project, status, item?._id)
    } else { handleProject(project) }
  }

  return (
    <>
      <Grid container>
        <Grid sx={style.mainBox}>
          <Box >
            <Typography variant="body1" sx={style.mainHeading}>
              {isEmployeeRole ? "My Projects" : "Projects"}
            </Typography>
          </Box>
          <Button variant="contained" sx={{ borderRadius: "30px", textTransform: "none" }}
            onClick={() => {
              setOpen(true);
              setFrom("Add");
              setItem("");
              setProject("");
              setStatus("");
            }}>Add Project</Button>
        </Grid>
        <Grid container>
          <Grid item xs={12} sx={{ ...style.gridbioBoxs, }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={style.TableHead}>Project Name</TableCell>
                    <TableCell sx={style.TableHead}>Status</TableCell>
                    <TableCell sx={style.TableHead}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {projectList.length > 0 ? (
                    projectList?.map((item, index) => {
                      return (<TableRow key={index}>
                        <TableCell>
                          <Typography sx={style.name}>{item?.name}</Typography></TableCell>
                        <TableCell>
                          <Typography sx={style.name}>{item?.status}</Typography></TableCell>
                        <TableCell sx={{ display: "flex", gap: "13px" }}>
                          <Edit onClick={() => { setFrom("Edit"); setOpen(true); setItem(item); }} sx={{ color: color.lightText, cursor: "pointer" }} />
                          <Delete sx={{ color: "#ff0000", cursor: "pointer" }} onClick={() => { deleteData(item?._id), setOpens(true); }} /></TableCell>
                      </TableRow>);
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <Typography align="center" sx={{ color: "gray" }}>
                          No projects found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Modal open={open} setOpen={setOpen} loading={loading} handleCheck={handleSubmit} btnText={from === "Edit" ? "Confirm" : "Add"} title={from === "Edit" ? "Edit Project" : "Add"} disabled={!isChanged}>
          <InputLabel sx={{ ...style.inputLabel }}>Project</InputLabel>
          <Box sx={{ ...style.inputContainer, marginBottom: "23px" }}>
            <TextField sx={style.modalInput} placeholder="Enter Project Name" value={project} onChange={(e) => { setProject(e.target.value); setChange(true) }} />
          </Box>
          {from === "Edit" &&
            <FormControl fullWidth sx={{
              "& .MuiOutlinedInput-root": {
                height: "2.5em",
                marginTop: "0.8em",
                borderRadius: "5px"
              }
            }} >
              <InputLabel shrink sx={{
                ...style.inputLabel,
                fontSize: "18px !important",
                ml: -1.5,
                mb: 1,
                position: "absolute",
                top: "-9px",
                color: "black !important",
                "&.Mui-focused": {
                  color: "black !important",
                },
              }}>Status</InputLabel>
              <Select
                value={status ? status : item?.status}
                onChange={(e) => setStatus(e.target.value)}
                name="status"
                sx={{ ...style.dropDownMenu, marginTop: "0.8em", marginBottom: "10px" }}
              >
                <MenuItem sx={style.dropDownMenu} value="Pending">Pending</MenuItem>
                <MenuItem sx={style.dropDownMenu} value="Completed">Completed</MenuItem>
                <MenuItem sx={style.dropDownMenu} value="Running">Running</MenuItem>
              </Select>
            </FormControl>}
        </Modal>
      </Grid>
      <Modal open={opens} setOpen={setOpens} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Project"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  )
}

export default ProjectPage
